module.exports = __webpack_public_path__ + "assets/avatar-woofyd.f6336115.svg";